/* eslint-disable react/prop-types, react/jsx-filename-extension */
import React from 'react';

import Date from '../../../common/date';
import Money from '../../../common/money';
import ImpersonateUser from '../../shared/ImpersonateUser';

export default [
  {
    Header: 'Name',
    accessor: 'name',
    id: 'name',
  },
  {
    Header: 'End of payout period',
    accessor: 'endOfPayout',
    id: 'endOfPayout',
    Cell: props => <Date date={props.value} timezone={props.original.timezone} />,
  },
  {
    Header: 'Last payout date',
    accessor: 'lastPayout',
    id: 'lastPayout',
    Cell: props => <Date date={props.value} timezone={props.original.timezone} />,
  },
  {
    Header: 'Total',
    accessor: 'total',
    id: 'total',
    Cell: props => <Money cents={props.value} />,
  },
  {
    Header: 'Auto transfers',
    accessor: 'commissionSplitsAutoDeposit',
    id: 'commissionSplitsAutoDeposit',
    Cell: props => (props.value ? 'On' : 'Off'),
  },
  {
    Header: 'Actions',
    accessor: 'userId',
    Cell: props => <ImpersonateUser id={props.value} />,
  }];
